import { Component, Input, OnInit, inject } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { ProviderService } from 'app/core/services/provider.service';
import { OutreachAttemptEvidence } from 'app/core/models/outreach-attempt-evidence.model';
import { keyedStatusOptions as keyedOfficeStatusOptions } from 'app/core/options/office-status.opts';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';
import { DatePipe } from '@angular/common';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-outreach-attempt-evidence',
    templateUrl: './outreach-attempt-evidence.component.html',
    styleUrls: ['./outreach-attempt-evidence.component.scss'],
    imports: [OfficeComponent, MatProgressSpinner, DatePipe]
})
export class OutreachAttemptEvidenceComponent implements OnInit {
  private providerService = inject(ProviderService);

  @Input() outreachAttemptEvidence: OutreachAttemptEvidence;
  @Input() provider: MinimalProvider;
  @Input() patientPrescriberId: number;

  loading = true;
  formValid = false;

  selectedProviderOffices: ProviderOffice[] = [];

  keyedOfficeStatusOptions = keyedOfficeStatusOptions;
  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;

  ngOnInit() {
    this.providerService.getProviderOffices(this.provider.id).
      subscribe(providerOffices => {
        this.selectedProviderOffices = providerOffices.filter(providerOffice =>
          this.outreachAttemptEvidence.officeIds.includes(providerOffice.office.id)
        );

        this.loading = false;
      });
  }

}
